import { render, staticRenderFns } from "./PdmGestao.vue?vue&type=template&id=29a5da03&scoped=true"
import script from "./PdmGestao.vue?vue&type=script&lang=js"
export * from "./PdmGestao.vue?vue&type=script&lang=js"
import style0 from "./PdmGestao.vue?vue&type=style&index=0&id=29a5da03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a5da03",
  null
  
)

export default component.exports